export default "__VITE_ASSET__CAnp55JP__"